import { detectPlatform } from './detect';
import { Platform } from './types';

// Dynamic imports so non-Capacitor builds don't pull native-only modules.
export const initCapacitorShell = (): void => {
  if (detectPlatform() !== Platform.Capacitor) return;

  void (async () => {
    try {
      const { StatusBar, Style } = await import('@capacitor/status-bar');
      // `Style.Light` = light bg with dark icons/text. Inverted Capacitor naming.
      await StatusBar.setStyle({ style: Style.Light });
      const bg =
        getComputedStyle(document.documentElement).getPropertyValue('--color-bg').trim() ||
        '#fbf7ee';
      await StatusBar.setBackgroundColor({ color: bg });
      // overlay=true → WebView extends under the bar, CSS safe-area handles spacing.
      await StatusBar.setOverlaysWebView({ overlay: true });
    } catch {
      // Module unavailable (non-Capacitor builds) — ignore.
    }

    try {
      const { ScreenOrientation } = await import('@capacitor/screen-orientation');
      await ScreenOrientation.lock({ orientation: 'portrait' });
    } catch {
      // Module unavailable (non-Capacitor builds) — ignore.
    }

    try {
      const { SplashScreen } = await import('@capacitor/splash-screen');
      // One frame so first paint lands before splash dies.
      requestAnimationFrame(() => {
        void SplashScreen.hide({ fadeOutDuration: 200 });
      });
    } catch {
      // Module unavailable (non-Capacitor builds) — ignore.
    }
  })();
};
